import SaleDetailsActionTypes from "./saleDetails.types";

export const fetchSaleDetailsStart = (data: any) => ({
  type: SaleDetailsActionTypes.FETCH_SALE_DETAILS_START,
  payload: data,
});

export const fetchSaleDetailsSuccess = (success: any) => ({
  type: SaleDetailsActionTypes.FETCH_SALE_DETAILS_SUCCESS,
  payload: success,
});

export const fetchSaleDetailsFailure = (failure: any) => ({
  type: SaleDetailsActionTypes.FETCH_SALE_DETAILS_FAILURE,
  payload: failure,
});

export const fetchSaleDetailsResponseResetStart = () => ({
  type: SaleDetailsActionTypes.FETCH_SALE_DETAILS_RESPONSE_RESET,
});

export const fetchSaleDetailsChanged = () => ({
  type: SaleDetailsActionTypes.FETCH_SALE_DETAILS_CHANGED,
});

export const createSaleStart = (data: any) => ({
  type: SaleDetailsActionTypes.CREATE_SALE_START,
  payload: data,
});

export const createSaleSuccess = (success: any) => ({
  type: SaleDetailsActionTypes.CREATE_SALE_SUCCESS,
  payload: success,
});

export const createSaleFailure = (failure: any) => ({
  type: SaleDetailsActionTypes.CREATE_SALE_FAILURE,
  payload: failure,
});

export const createSaleResponseResetStart = () => ({
  type: SaleDetailsActionTypes.CREATE_SALE_RESPONSE_RESET,
});

export const createSaleChanged = () => ({
  type: SaleDetailsActionTypes.CREATE_SALE_CHANGED,
});

export const updateSaleStart = (data: any) => ({
  type: SaleDetailsActionTypes.UPDATE_SALE_START,
  payload: data,
});

export const updateSaleSuccess = (success: any) => ({
  type: SaleDetailsActionTypes.UPDATE_SALE_SUCCESS,
  payload: success,
});

export const updateSaleFailure = (failure: any) => ({
  type: SaleDetailsActionTypes.UPDATE_SALE_FAILURE,
  payload: failure,
});

export const updateSaleResponseResetStart = () => ({
  type: SaleDetailsActionTypes.UPDATE_SALE_RESPONSE_RESET,
});

export const updateSaleChanged = () => ({
  type: SaleDetailsActionTypes.UPDATE_SALE_CHANGED,
});
